import React from "react";
import { Link } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { FinalLogo } from "../../lib/assets";

import { MobileMenu } from "./MobileMenu";
import { NavMenus } from "./NavMenus";
import { useStickyMenu } from "../../lib/hooks/useStickyMenu";

export const HeaderThree = () => {
  // menu sticky
  useStickyMenu();
const isMobile = window.innerWidth < 768;

  return (
    <header
      id="sticky-header"
      className="transparent-header header-style-three"
    >
      <div className="menu-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="mobile-nav-toggler">
                <i className="fas fa-bars"></i>
              </div>
              <div className="menu-wrap" >
                <nav className="menu-nav">
                  <div className="logo">
                    <Link to="/">
                    {/* <img src={FinalLogo} alt="Logo"   style={{zoom:"400%", paddingLeft:"0px"}}   />

                    */}
                      <img src={FinalLogo} alt="Logo"    style={{  zoom: isMobile ? "120%" : "200%" }} />
                    </Link>
                  </div>

                  {/* nav links */}
                  <NavMenus />

                  <div className="header-action">
                    <ul className="list-wrap">
                   {/*   <li className="header-search">
                        <a href="#">
                          <i className="flaticon-search"></i>
                        </a>
                      </li> 
                      <li className="offcanvas-menu offcanvas-menu-two">
                        <a href="#" className="menu-tigger">
                          <span></span>
                          <span></span>
                          <span></span>
                        </a>
                      </li>*/}
                      <li className="header-contact-two">
                        <div className="icon">
                          <i className="flaticon-phone-call"></i>
                        </div>
                        <div className="content">
                          <span>Phone Number</span>
                         <a href="tel:+91 9841012134"> +91 - 98410 12134 / +91 - 98416 71160</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              {/* Mobile Menu  */}
              <MobileMenu />
            </div>
          </div>
        </div>
      </div>

      {/* header-search 
      <HeaderSearch /> */}

      {/* sidebar */}
      <Sidebar />
    </header>
  );
};
